import React from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { createUnionDelegationService } from '../../../../Domain/Services/UnionDelegationService/CreateUnionDelegationServiceService';
import { getUnionDelegationServiceService } from '../../../../Domain/Services/UnionDelegationService/GetUnionDelegationServiceService';
import { patchUnionDelegationServiceService } from '../../../../Domain/Services/UnionDelegationService/PatchUnionDelegationServiceService';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { useTranslation } from 'react-i18next';
import { PRIVATE_USER_LIST_DELEGATION_SERVICE, PRIVATE_USER_LIST_UNION_DELEGATION_SERVICE } from '../../../Constants/PathsConstants';
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import PropTypes from "prop-types";
import { toast } from 'react-toastify';
import { useParams, Link as RouterLink, useNavigate } from "react-router-dom";
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { GESTOR_DELEGACIONES_SERVICIOS } from 'Shared/Security/Application/Constants/PermissionsConstant';

FormUnionDelegationServiceView.propTypes = {
    id: PropTypes.string,
};

function FormUnionDelegationServiceView() {
    const { t } = useTranslation();

    const { id } = useParams();

    const [unionName, setUnionName] = React.useState("");
    const [sendingApiRequest, setSendingApiRequest] = React.useState(false);
    const navigate = useNavigate();
    const { checkPermission } = useAuthContext();
    const [hasAdminPermission, setHasAdminPermission] = React.useState(false);
    console.log(hasAdminPermission);
    React.useEffect(() => {

        const admin = checkPermission(GESTOR_DELEGACIONES_SERVICIOS);

        setHasAdminPermission(admin);

        if (!admin) {
            navigate(PRIVATE_USER_LIST_DELEGATION_SERVICE, { replace: true });
        }
    }, [checkPermission, navigate]);


    React.useEffect(() => {
        if (!id || id === "new") {
            setUnionName("");
            return;
        }

        setSendingApiRequest(true);

        getUnionDelegationServiceService(id)
            .then((response) => {
                if (response && response.name) {
                    setUnionName(response.name);
                } else {
                    setUnionName("");
                }
            })
            .catch((error) => {
                toast.error(t("unionDelegationService.restore.error"));
                console.error("Error fetching union delegation service:", error);
                setUnionName("");
            })
            .finally(() => {
                setSendingApiRequest(false);
            });
    }, [id]);

    const handleUnionNameChange = (event) => setUnionName(event.target.value);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (sendingApiRequest) return;
        setSendingApiRequest(true);

        try {
            let apiResponse = null;

            if (id === "new") {
                apiResponse = await createUnionDelegationService({
                    name: unionName,
                });
            } else {
                apiResponse = await patchUnionDelegationServiceService(id, {
                    name: unionName,
                });
            }

            if (apiResponse !== null) {
                window.location.href = process.env.PUBLIC_URL + PRIVATE_USER_LIST_UNION_DELEGATION_SERVICE;
            }
        } catch (error) {
            console.error(error);
        } finally {
            setSendingApiRequest(false);
        }
    };

    return (
        <>
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    minHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 3,
                    px: 2,
                }}
            >
                <Typography variant="h4" textAlign="center">
                    {id === "new" ? t('unionDelegationService.form.create') : t('unionDelegationService.form.update')}
                </Typography>

                <TextField
                    required
                    label={t('unionDelegationService.form.unionDelegationServiceName')}
                    variant="outlined"
                    value={unionName}
                    onChange={handleUnionNameChange}
                    sx={{ width: "100%", maxWidth: 400 }}
                />

                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                    <Button
                        variant="contained"
                        color="error"
                        component={RouterLink}
                        to={PRIVATE_USER_LIST_UNION_DELEGATION_SERVICE}
                        startIcon={<CancelIcon />}
                        sx={{
                            fontWeight: 'bold',
                            borderRadius: 2,
                            textTransform: 'none',
                        }}
                    >
                        {t('unionDelegationService.form.cancel')}

                    </Button>

                    <Button
                        variant="contained"
                        type="submit"
                        startIcon={<SaveIcon />}
                        sx={{
                            backgroundColor: "#0492D4",
                            color: "white",
                            fontWeight: 'bold',
                            borderRadius: 2,
                            textTransform: 'none',
                            "&:hover": {
                                backgroundColor: "#037bb5",
                            },
                        }}
                    >
                        {id === "new" ? t('unionDelegationService.form.create') : t('unionDelegationService.form.update')}
                    </Button>
                </Box>
            </Box>

            <DialogLoader open={sendingApiRequest} />
        </>
    );
}

export default FormUnionDelegationServiceView;
